import React from 'react';
import WhipStatsDemo from 'src/js/component-tester/components/WhipStatsDemo';

export const WhipStatsStartedTest: React.FunctionComponent = () => (
  <div className="test-zone">
    <WhipStatsDemo />
  </div>
);
